import { endpoints } from "../config";
import { getData, postData, putData, deleteData } from "./api-utils";

const routeURL = endpoints.answer;

const getAnswer = async (questionId) => {
  return await getData(`${routeURL}/${questionId}`);
};

const postAnswer = async (data) => {
  return await postData(routeURL, data);
};

const updateAnswer = async (data, itemId) => {
  return await putData(`${routeURL}/${itemId}`, data);
};
const deleteAnswer = async (itemId) => {
  return await deleteData(`${routeURL}/${itemId}`);
};

export { getAnswer, postAnswer, updateAnswer, deleteAnswer };
